/**
 * Component for our Report showing most-returned Products.
 * 
 * @component
 */

import React from "react";
import Report from "../Report";
import Stats from "./Stats";


const exportHeaders = [
  {
    label: "Product Name",
    value: "productName",
  },
  {
    label: "Return Reasons",
    value: "returnReasons",
  },
  {
    label: "Customer Notes",
    value: "notes",
  },
  {
    label: "Count",
    value: "productCount",
  },
];

class Products extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalRecord: {},
      showModal: false,
    }
  }

  handleCancel = () => {
    this.setState({
      modalRecord: {},
      showModal: false,
    })
  }
  columns = [
    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Return Reasons",
      dataIndex: "returnReasons",
      render: (items) => {
        return items?.map((item, index) => <span key={index}>{item}, <br/></span>)
      }
    },
    {
      title: "Customer Notes",
      dataIndex: "notes",
      render: (items) => {
        return items?.map((item, index) => <span key={index}>{item}, <br/></span>)
      }
    },
    {
      title: "Count",
      dataIndex: "productCount",
    },
    {
      title: "Details",
      render: (_, record) => (
        <a onClick={() => {this.setState({modalRecord: record, showModal: true})}}>View</a>
      )
    }
  ];
  render() {
    return (
      <React.Fragment>
        <Report
          url="/api/reports/products/by-product"
          title="Most Returned Products"
          tooltip="This report shows how many times a product was returned within the selected date range."
          columns={this.columns}
          reportName="most-returned-products"
          exportHeaders={exportHeaders}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          updateDate={this.props.updateDate}
        />
        {this.state.showModal &&
          <Stats
            url="/api/reports/products/by-product"
            reportName="most-returned-products"
            modalRecord={this.state.modalRecord}
            visible={this.state.showModal}
            handleCancel={this.handleCancel}
            startDate={this.props.startDate}
            endDate={this.props.endDate}
          />
        }
      </React.Fragment>
    );
  }
}

export default Products;
